import url_ from "asset-data:assets/galleries/test/L1000402-bw_34ba1ac335__400.jpg";
export const url = url_;